import asyncErrorHandler, { IErrorHandlerResponse } from 'utils/requests/errorHandler';
import request from './request.service';
import { apiUrls } from 'constants/urls';
import { ICaptchaRequest } from 'types/request';

interface SendResetPasswordLinkParams extends ICaptchaRequest {
  email: string;
}

type SendResetPasswordLinkResponse = IErrorHandlerResponse<null>;

export const sendResetPasswordLink = async (
  body: SendResetPasswordLinkParams,
): Promise<SendResetPasswordLinkResponse> => {
  const callback = async () => {
    return await request(apiUrls.auth.resetPasswordLink, {
      method: 'POST',
      body,
    });
  };

  return await asyncErrorHandler(callback);
};

interface ChangePasswordLinkParams {
  password: string;
  token: string;
  totp: string;
}

type ChangePasswordLinkResponse = IErrorHandlerResponse<null>;

export const changePassword = async ({
  password,
  token,
  totp,
}: ChangePasswordLinkParams): Promise<ChangePasswordLinkResponse> => {
  const callback = async () => {
    return await request(apiUrls.admin.main, {
      method: 'POST',
      body: { password, token, totp },
    });
  };

  return await asyncErrorHandler(callback);
};

interface CheckNewPasswordTokenParams {
  token: string;
}

type CheckNewPasswordTokenResponse = IErrorHandlerResponse<{ '2fa': boolean; totp: string; isActive: boolean }>;

export const checkNewPasswordToken = async ({
  token,
}: CheckNewPasswordTokenParams): Promise<CheckNewPasswordTokenResponse> => {
  const callback = async () => {
    return await request(apiUrls.auth.token, {
      params: { token },
    });
  };

  return await asyncErrorHandler(callback);
};
